import Vue from "vue";
import { faviconLinks } from "@utils";

function applyFavicons(links) {
	// remove only the nodes we manage
	const selector = links
		.map((link) => `link[data-hid="${link.hid}"]`)
		.join(",");

	if (selector) {
		document.head
			.querySelectorAll(selector)
			.forEach((element) => element.remove());
	}

	// add fresh ones
	links.forEach((link) => {
		const el = document.createElement("link");
		el.setAttribute("rel", link.rel);
		if (link.type) {
			el.setAttribute("type", link.type);
		}
		if (link.sizes) {
			el.setAttribute("sizes", link.sizes);
		}
		el.setAttribute("href", link.href);

		// mark for future cleanup
		if (link.hid) {
			el.setAttribute("data-hid", link.hid);
		}

		document.head.appendChild(el);
	});
}

Vue.mixin({
	watch: {
		$isBlueBranding(val) {
			applyFavicons(faviconLinks({ isBlueBranding: val }));
		},
	},
	mounted() {
		// Only run once (your layouts mount once; but guard anyway)
		if (this.$root && this.$root.__faviconsInitialized) {
			return;
		}
		if (this.$root) {
			this.$root.__faviconsInitialized = true;
		}

		// Force on first client render
		applyFavicons(faviconLinks({ isBlueBranding: this.$isBlueBranding }));
	},
});
